import { useState } from "react";
import { FaStarOfLife } from "react-icons/fa";
import "../../style/mobile/profile/MProfile.scss";

let data = [
  {
    id: 1,
    title: "مشخصات شخصی",
    subtitle:
      "در این قسمت نام و نام خانوادگی و کد ملی خود را به صورت صحیح واردنمائید",
    forms: [
      {
        id: 11,
        counter: 1,
        label: "نام",
        type: "text",
        required: true,
        default: "",
      },
      {
        id: 12,
        label: "نام خانوادگی",
        type: "text",
        required: true,
        counter: 2,
      },
      {
        id: 13,
        label: "کد ملی",
        type: "number",
        required: true,
        counter: 3,
      },
    ],
  },
  {
    id: 2,
    title: "مشخصات ارتباطی",
    subtitle: "شماره موبایل جهت ارتباط با شما استفاده خواهد شد",
    forms: [
      {
        id: 21,
        label: "شماره موبایل",
        type: "number",
        required: true,
        counter: 4,
      },
      {
        id: 22,
        label: "شماره تلفن ثابت",
        type: "number",
        required: false,
        counter: 5,
      },
    ],
  },
  {
    id: 3,
    title: "مشخصات تحصیلی",
    subtitle:
      "مشخصات تحصیلی و محل تحصیل جهت ارائه بهترین پیشنهادهای آموزشی برای شما خواهد بود",
    forms: [
      {
        id: 31,
        label: "",
        type: "select",
        required: true,
        counter: 5,
        options: [
          {
            id: 310,
            option: "پایه تحصیلی",
          },
          {
            id: 311,
            option: "اول",
          },
          {
            id: 312,
            option: "دوم",
          },
          {
            id: 313,
            option: "سوم",
          },
          {
            id: 314,
            option: "چهارم",
          },
          {
            id: 315,
            option: "پنجم",
          },
          {
            id: 316,
            option: "ششم",
          },
          {
            id: 317,
            option: "هفتم",
          },
          {
            id: 318,
            option: "هشتم",
          },
          {
            id: 319,
            option: "نهم",
          },
          {
            id: 3110,
            option: "دهم",
          },
          {
            id: 3111,
            option: "یازدهم",
          },
          {
            id: 3112,
            option: "دوازدهم",
          },
        ],
      },
      {
        id: 32,
        label: "نام محل تحصیل",
        type: "text",
        required: false,
        counter: 6,
      },
    ],
  },
  {
    id: 4,
    title: "مشخصات حساب کاربری",
    subtitle:
      "این مشخصات جهت ورود به حساب کاربری شما مورد استفاده قرار می گیرد. توجه داشته باشید که این اطلاعات را به صورت دقیق وارد نمائید",
    forms: [
      {
        id: 41,
        counter: 7,
        label: "آدرس ایمیل",
        type: "email",
        required: true,
      },
      {
        id: 42,
        label: "نام کاربری",
        type: "text",
        required: true,
        counter: 8,
      },
      {
        id: 43,
        label: "رمز عبور",
        type: "password",
        required: true,
        counter: 9,
      },
      {
        id: 44,
        label: "تکرار رمز عبور",
        type: "password",
        required: true,
        counter: 10,
        error: "رمز عبور‌ها یکسان نیست. مجددا وارد نمایید",
      },
    ],
  },
];

const MProfile = () => {
  const [error, setError] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
  const [password, setPassword] = useState("");

  const labelPositionHandler = (index) => {
    let label = document.querySelectorAll(
      ".MProfile-body-item-form-box-item-label"
    );
    // console.log(label);
    if (index > 5) {
      label[index].style.top = "-3px";
      label[index].style.right = "9%";
      label[index].style.color = "#2E81E8";
    } else {
      label[index - 1].style.top = "-3px";
      label[index - 1].style.right = "9%";
      label[index - 1].style.color = "#2E81E8";
    }
    let input = document.querySelectorAll(
      ".MProfile-body-item-form-box-item-input"
    );
    input[index - 1].style.borderColor = "#2E81E8";
  };
  const labelPositionHandler2 = (e, index) => {
    if (e.target.value.length === 0) {
      let label = document.querySelectorAll(
        ".MProfile-body-item-form-box-item-label"
      );
      if (index > 5) {
        label[index].style.top = "50%";
        label[index].style.right = "11%";
        label[index].style.color = "#A2B4CB";
      } else {
        label[index - 1].style.top = "50%";
        label[index - 1].style.right = "11%";
        label[index - 1].style.color = "#A2B4CB";
      }
      let input = document.querySelectorAll(
        ".MProfile-body-item-form-box-item-input"
      );
      input[index - 1].style.borderColor = "#E0E0E0";
    }
    //check password-----------------------------------
    if (index === 9) {
      setPassword(e.target.value);
    }
    if (index === 10 && password !== e.target.value) {
      let input = document.querySelectorAll(
        ".MProfile-body-item-form-box-item-input"
      );
      input[index - 1].style.borderColor = "#E80000";
      setError([0, 0, 0, 0, 0, 0, 0, 0, 0, 1]);
      let label = document.querySelectorAll(
        ".MProfile-body-item-form-box-item-label"
      );
      label[index].style.color = "#E80000";
      // console.log("error----------------");
    }
    if (index === 10 && password === e.target.value) {
      // let input = document.querySelectorAll(".Profile-body-item-form-box-item-input");
      // input[index-1].style.borderColor="#2E81E8";
      setError([0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
      // let label = document.querySelectorAll(".Profile-body-item-form-box-item-label");
      // label[index].style.color="#2E81E8";
    }
  };
  return (
    <div className="MProfile">
      <div className="MProfile-title">اطلاعات حساب کاربری</div>
      <div className="MProfile-body">
        {data.map((item, index1) => (
          <div key={item.id} className="MProfile-body-item">
            <div className="MProfile-body-item-title-box">
              <div className="MProfile-body-item-title-box-title">
                {item.title}
              </div>
              <div className="MProfile-body-item-title-box-subtitle">
                {item.subtitle}
              </div>
            </div>
            <div className="MProfile-body-item-form-box">
              {item.forms.map((item) => (
                <div key={item.id} className="MProfile-body-item-form-box-item">
                  <FaStarOfLife
                    style={!item.required ? { opacity: "0" } : null}
                    className="MProfile-body-item-form-box-item-icon"
                  />
                  <label
                    htmlFor={`MProfile-body-item-form-box-item-input-${
                      index1 + 1
                    }`}
                    className="MProfile-body-item-form-box-item-label"
                    style={item.default ? { top: "-3px", right: "9%" } : null}
                  >
                    {item.label}
                  </label>
                  {item.type !== "select" && (
                    <input
                      type={item.type}
                      defaultValue={item.default}
                      name={`MProfile-body-item-form-box-item-input-${
                        index1 + 1
                      }`}
                      className="MProfile-body-item-form-box-item-input"
                      id={`MProfile-body-item-form-box-item-input-${item.id + 1}`}
                      onFocus={() => labelPositionHandler(item.counter)}
                      onBlur={(e) => labelPositionHandler2(e, item.counter)}
                    />
                  )}
                  {error[item.counter - 1] > 0 && (
                    <div className="MProfile-body-item-form-box-item-error-message">
                      {item.error}
                    </div>
                  )}
                  {item.type === "select" && (
                    <select className="MProfile-body-item-form-box-item-select">
                      {item.options.map((item) => (
                        <option
                          key={item.id}
                          value={item.option}
                          className="MProfile-body-item-form-box-item-select-option"
                        >
                          {item.option}
                        </option>
                      ))}
                    </select>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
        <div className="MProfile-body-item">
          <div className="MProfile-body-item-title-box">
            <div className="MProfile-body-item-title-box-title">
              شرایط استفاده و حریم خصوصی
            </div>
            <div className="MProfile-body-item-title-box-subtitle">
              برای استفاده از سرویس آزمون نیاز به پذیرفتن شرایط استفاده و حریم
              خصوصی هستید. شما میتوانید با کلیک روی هر کدام موارد مربوط به آن ها
              را مطالعه نمائید
            </div>
          </div>
          <div className="MProfile-body-item-form-box">
            <div className="MProfile-body-item-form-box-privacy">
              <input
                type="checkbox"
                name="MProfile-body-item-form-box-privacy-input"
                id="MProfile-body-item-form-box-privacy-input"
                className="MProfile-body-item-form-box-privacy-input"
              />
              <div className="MProfile-body-item-form-box-privacy-label">
                با قوانین شرایط استفاده و حریم خصوصی موافق هستم
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="MProfile-btn">ذخیره تغییرات</div>
    </div>
  );
};

export default MProfile;